import { Injectable, signal } from '@angular/core';

const PLAYBACK_RATES = [1, 1.5, 2] as const;
const PLAYBACK_RATE_STORAGE_KEY = 'fc-audio-playback-rate';

export type PlaybackRate = (typeof PLAYBACK_RATES)[number];

@Injectable({ providedIn: 'root' })
export class AudioPlaybackCoordinatorService {
  private pauseActivePlayer: (() => void) | null = null;

  readonly playbackRate = signal<PlaybackRate>(readStoredPlaybackRate());

  claimPlayback(pausePlayer: () => void): void {
    if (this.pauseActivePlayer && this.pauseActivePlayer !== pausePlayer) {
      this.pauseActivePlayer();
    }
    this.pauseActivePlayer = pausePlayer;
  }

  releasePlayback(pausePlayer: () => void): void {
    if (this.pauseActivePlayer === pausePlayer) this.pauseActivePlayer = null;
  }

  cyclePlaybackRate(): void {
    const currentIndex = PLAYBACK_RATES.indexOf(this.playbackRate());
    const nextRate = PLAYBACK_RATES[(currentIndex + 1) % PLAYBACK_RATES.length];
    this.playbackRate.set(nextRate);
    try {
      localStorage.setItem(PLAYBACK_RATE_STORAGE_KEY, String(nextRate));
    } catch {
      return;
    }
  }
}

function readStoredPlaybackRate(): PlaybackRate {
  try {
    const storedRate = Number(localStorage.getItem(PLAYBACK_RATE_STORAGE_KEY));
    return PLAYBACK_RATES.find((rate) => rate === storedRate) ?? 1;
  } catch {
    return 1;
  }
}
